import { ConfigService } from './../../../services/config/config.service';
import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot, UrlTree } from '@angular/router';

@Injectable({
    providedIn: 'root',
})
class CVRGuardService {
    constructor(private router: Router, private configService: ConfigService) {}

    public canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
        if (this.configService.getFeaturesConfig().enable_cvr === 'true') {
            return true;
        }
        return this.router.parseUrl('/');
    }
}

export const CVRGuard: CanActivateFn = (next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree => {
    return inject(CVRGuardService).canActivate(next, state);
};
